import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { CepCoordinate, CustomerLocations } from './customer-location.entity'

export class GeoRepository extends BaseRepository<CustomerLocations> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/geo/customers', token, cache)
    }

    // Mesma resposta do getAll, mas com a amostra saindo de uma lista de pessoas. POST porque a
    // lista chega a milhares de UUIDs e não caberia na URL.
    async getByPersonIds(personIds: string[], limit: number): Promise<CustomerLocations> {
        const url = this.config.eventApiUrl + '/geo/customers/?token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.post(url, { personIds, limit })
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}

// Repositório separado porque a rota é outra (/geo/cep/:cep) e o getOne do BaseRepository
// monta a URL a partir do endpoint base.
export class CepGeoRepository extends BaseRepository<CepCoordinate> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/geo/cep', token, cache)
    }
}
